export default function ToggleRow({
  label,
  sub,
  checked,
  onChange,
}: {
  label: string;
  sub: string;
  checked: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <button
      type="button"
      onClick={() => onChange(!checked)}
      className="flex min-h-[52px] items-center justify-between rounded-2xl border border-border bg-white px-5 text-left"
    >
      <span>
        <span className="block font-semibold">{label}</span>
        <span className="block text-xs text-mutedLight">{sub}</span>
      </span>
      <span
        className={`flex h-7 w-[50px] shrink-0 items-center rounded-full p-[3px] transition-colors ${
          checked ? "bg-indigo" : "bg-[#D4D2CB]"
        }`}
      >
        <span
          className={`block h-5 w-5 rounded-full shadow-sm transition-transform ${
            checked ? "translate-x-[22px] bg-white" : "translate-x-0 bg-ink"
          }`}
        />
      </span>
    </button>
  );
}
